module.exports = __webpack_public_path__ + "static/media/ts13tj93.4db369ef.png";